import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, DropdownSelectField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from './TanningEquInformationComponent.module.scss';
import metadata from './TanningEquInformationComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function TanningEquInformationComponent(props) {

    const {
        data: TanningEquipmentInformationVM,
        updateWizardData,
        submissionVM,
        TanningEquipmentInformationPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


    const addTanningEquipmentInformation = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            TanningEquipmentInformationVM.value = TanningEquipmentInformationVM.value || []

            const { _xCenter, _dtoName } = TanningEquipmentInformationVM;

            const TanningEquipmentInformationObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            TanningEquipmentInformationObjVM.isValidationReq.value = true;

            TanningEquipmentInformationVM.pushElement(
                TanningEquipmentInformationObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, TanningEquipmentInformationVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            TanningEquipmentInformationVM.value.splice(index, 1);
            _.set(submissionVM.value, TanningEquipmentInformationPath, TanningEquipmentInformationVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, TanningEquipmentInformationPath, TanningEquipmentInformationVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'equFie') {
                const value = (item && item.equFie) ? item.equFie : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = TanningEquipmentInformationVM.length > 0 && TanningEquipmentInformationVM.children[index].equFie
                    // eslint-disable-next-line security/detect-object-injection
                    ? TanningEquipmentInformationVM.children[index].equFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.equFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'quaFie') {
                const value = item.quaFie ? item.quaFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.quaFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'aveAgeFie') {
                const value = item.aveAgeFie ? item.aveAgeFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.aveAgeFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'typofTimFie') {
                const value = (item && item.typofTimFie) ? item.typofTimFie : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = TanningEquipmentInformationVM.length > 0 && TanningEquipmentInformationVM.children[index].typofTimFie
                    // eslint-disable-next-line security/detect-object-injection
                    ? TanningEquipmentInformationVM.children[index].typofTimFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.typofTimFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }


        }, [handleValueChange, translator, TanningEquipmentInformationVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`TanningEquipmentInformationTable`]: {
            data: TanningEquipmentInformationVM.value,
        }

    }), [TanningEquipmentInformationVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addTanningEquipmentInformation,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            TanningEquipmentInformationVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [TanningEquipmentInformationVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={TanningEquipmentInformationVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

TanningEquInformationComponent.propTypes = wizardProps;
export default withRouter(TanningEquInformationComponent);
